import { ViesStatus } from 'store/app/enums';
import { TransactionAttachment } from './transactionAttachments';
export interface VatReportData {
  summary?: BoxSummary[] | null;
  contacts: DataContact[] | null;
  journals: DataJournal[] | null;
  summarizedJournals: DataJournal[] | null;
  exceptions: DataJournal[] | null;
  currencySymbol: string | null;
  page?: number | null;
  pageSize: number;
  totalPages: number;
  success: boolean;
  message: string;
  httpStatus: string | null;
  sections: TaxReportSectionDataResponse[];
  subsections: TaxReportSubsectionDataResponse[];
  adjustedSubsections: TaxReportSubsectionDataResponse[] | null;
  recap: boolean;
  accrualsLastId: number | null;
  cashAccountingLastId: number | null;
  empty: boolean;
  transactionsSize: number;
  exceptionsSize: number;
  othersSize?: number;
  summarizedSize: number;
  detailedSize?: number;
  status?: string;
  dataStatus: string | null;
  hasReconciliationExceptions: boolean;
  incorrectTaxRates: string[] | null;
  manualJournalId: string | null;
  manualJournalUrl: string | null;
  newSummary: BoxSummary[] | null;
  savedTotals: boolean;
  totalTaxTransactions: number | null;
  totalTaxExceptions: number | null;
  totalTaxOthers?: number | null;
}

export interface BoxSummary {
  boxName: string;
  net: number;
  gross: number;
  tax: number;
  isGenerated: boolean;
}

export interface DataContact {
  name: string;
  country: string;
  taxNumber: string;
  viesStatus: ViesStatus;
  goodsSum: number;
  servicesSum: number;
  triangularTradeSum: number;
  isTriangularTrade: boolean;
  providerContactId: string;
}

export interface DataJournal {
  entityName?: string;
  entity?: string;
  entityProviderName?: string;
  taxName: string;
  journalDate: string | number;
  sourceId: string;
  sourceType: string;
  contact: string;
  invoiceNumber: string;
  accountCode: string;
  accountType: string;
  accountName: string;
  reference: string;
  description: string;
  currency: string;
  netAmount: number;
  taxAmount: number;
  modifiedNetAmount: number;
  modifiedTaxAmount: number;
  grossAmount: number;
  netAmountConverted: number;
  taxAmountConverted: number;
  grossAmountConverted: number;
  journalNumber: number;
  journalCreatedDate: string | number;
  invoiceId: string;
  paymentStatus: string | null;
  selectedValue: string;
  sourceUrl: string;
  appliedAmount: number | null;
  uuid: string;
  taxType: string;
  taxRate: number;
  valueModifier?: number;
  error: string | null;
  exceptionActionType?: string | null;
  key?: any;
  type: DataJournalType;
  isProcessed: boolean;
  deferredCount?: number | null;
  isReverseCharge: boolean;
  reverseChargeAmount: number;
  uploadDate?: string | number;
  transactionAttachments?: TransactionAttachment[];
  hasAttachments?: boolean;
  sortId?: number;
  country?: string | null;
  applicationConnectionId?: string;
}

export enum DataJournalType {
  EXCEPTION = 'EXCEPTION',
  TRANSACTION = 'TRANSACTION',
}

export interface TaxReportSectionDataResponse {
  name: string;
  sortOrder?: number | null;
}

export interface TaxReportSubsectionDataResponse {
  name: string;
  code: string;
  net: number;
  tax: number;
  sortOrder: number;
  booleanExpression: boolean;
  cellName: string;
  hint?: string;
}

export interface ExcelFileResponse {
  file: string;
  fileName: string;
}

export interface ReportPage {
  journals: any[];
  transactionsSize: number;
  exceptionsSize: number;
}

export interface MappingCodes {
  mappingCodes: string[];
}

export interface AccountFilter {
  code: string;
  name: string;
  type: string;
}
export interface AccountsFilter {
  accounts: AccountFilter[];
}

export interface TaxRateFilter {
  name: string;
}
export interface TaxRatesFilter {
  taxRates: TaxRateFilter[];
}

export enum JournalType {
  EXCEPTION = 'exception',
  TRANSACTION = 'transaction',
}

/** Mapping label for the "Other" bucket (same strings as filter dropdown / reconciliation). */
export function isOtherVatMappingLabel(
  value: string | undefined | null
): boolean {
  if (value == null || typeof value !== 'string') return false;
  const t = value.trim().toLowerCase();
  if (t === 'other') return true;
  if (t.endsWith(' other') || t.endsWith('- other') || t.endsWith('— other')) {
    return true;
  }
  return false;
}
